import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName, processApi
} from "../../../utility/index";
import {
    downLoadCarTemplateFile,
    exportCarXLXS
} from '../../../api/config/modules/VehicleFiles';
import moment from "moment";

export default {
    name: 'VehicleAnnualReview',
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                carExpiresType: '',
                carExpiresTime: [],
            },
            StateList: [
                {
                    value: '',
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('common.normal')
                },
                {
                    value: '1',
                    label: this.$t('common.nearTime')
                },
                {
                    value: '2',
                    label: this.$t('common.exceedTime')
                }
            ],
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.manufactureNum')
            }, {
                value: '3',
                label: this.$t('common.plateNum')
            }, {
                value: '4',
                label: this.$t('common.customNum')
            }],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "carId",
                label: this.$t('common.carId'),
                align: "center",
                width: "120px"
            },
            {
                prop: "manufactureNum",
                label: this.$t('common.manufactureNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "customNum",
                label: this.$t('common.customNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "plateNum",
                label: this.$t('common.plateNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",
                width: "120px"
            },
            {
                prop: "carExpires",
                label: this.$t('DriverManagement.driverExpires'),
                align: "center",
                width: "160px",
                // render: (h, params) => {
                //     return h('span', this.$formatDate(params.row.carExpires))
                // }
            },
            {
                prop: "carExpiresType",
                label: this.$t('DriverManagement.driverExpiresType'),
                align: "center",
                width: "120px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.carExpiresType === null ? '' : params.row.carExpiresType === 0 ? 'success' : params.row.carExpiresType === 1 ? 'warning' : 'danger' }
                    }, params.row.carExpiresType === null ? '' : params.row.carExpiresType === 0 ? this.$t('common.normal') : params.row.carExpiresType === 1 ? this.$t('common.nearTime') : this.$t('common.exceedTime'))
                }
            },
            {
                prop: "brandName",
                label: this.$t('common.brand'),
                align: "center",
                width: "140px"
            },
            {
                prop: "brandTypeName",
                label: this.$t('common.model'),
                align: "center",
                width: "140px"
            },
            {
                prop: "type",
                label: this.$t('VehicleManagement.powerType'),
                align: "center",
                width: "120px"
            },
            {
                prop: "capacity",
                label: this.$t('VehicleManagement.capacity'),
                align: "center",
                width: "120px"
            },
            {
                prop: "deliveryTime",
                label: this.$t('VehicleManagement.deliveryTime'),
                align: "center",
                width: "160px",
                // render: (h, params) => {
                //     return h('span', this.$formatDate(params.row.deliveryTime))
                // }
            },
            {
                prop: "remarks",
                label: this.$t('common.remark'),
                align: "center",
                width: "160px"
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont icontupian',
                        plain: true,
                        disabled: false,
                        isBtn: "VEHICLEANNUALREVIEW_PIC",
                        method: (index, row) => {
                            this.dialogImgFormVisible = true
                            this.imgUrl = row.filePath
                        }
                    }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,

            selected: [],
            disabled: '',
            formLabelWidth: '140px',
            dialogFormVisible: false,
            btnType: '',
            rules: {
                changeExpireDate: [
                    { required: true, message: this.$t('common.btn.choseDate'), trigger: 'change' },
                ],
                filePath: [
                    { required: true, message: this.$t('common.btn.uploadPicture'), trigger: 'blur' },
                ]
            },
            form: {
                carId: '',
                manufactureNum: '',
                customNum: '',
                plateNum: '',
                carExpires: '',
                expiresInstitution: '',
                changeExpireDate: '',
                carExpiresNum: '',
                filePath: ''
            },
            processImg: processApi,
            FileList: [],
            imageUrl: '',

            dialogOperateFormVisible: false,
            operatesList: [],
            operatesHeight: '350px',
            allColumns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "jurisdictionName",
                    label: this.$t('JurisdictionalManagement.jurisdictionName'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "nowExpireDate",
                    label: this.$t('VehicleManagement.currentExpirationDate'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "changeExpireDate",
                    label: this.$t('VehicleManagement.changeExpireDate'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "auditState",
                    label: this.$t('DriverManagement.auditState'),
                    align: "center",
                    width: "120px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.auditState === null ? '' : params.row.auditState === 0 ? 'warning' : params.row.auditState === 1 ? 'success' : 'danger' }
                        }, params.row.auditState === null ? '' : params.row.auditState === 0 ? this.$t('VehicleManagement.unapproved') : params.row.auditState === 1 ? this.$t('VehicleManagement.passed') : this.$t('VehicleManagement.rejected'))
                    }
                },
                {
                    prop: "auditOpinion",
                    label: this.$t('DriverManagement.auditOpinion'),
                    align: "center",
                    width: "120px"
                },
            ],
            allOperates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            OperatesCurrentPage: 1,
            OperatesPageSize: 10,
            OperatesTotal: 1,

            dialogImgFormVisible: false,
            imgUrl: '',
            select: []
        }
    },
    created() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            if (this.$route.params.carExpirationId) {
                this.formInline.carExpiresType = this.$route.params.carExpirationId
            }
            this.getAllCar()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllCar()
        },
        getAllCar() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.carExpiresTime) {
                if (this.formInline.carExpiresTime.length > 0) {
                    startTime = this.formInline.carExpiresTime[0]
                    endTime = this.formInline.carExpiresTime[1]
                }
            }
            let param = {
                companyId: sessionStorage.getItem("companyId"),
                orgId: this.id,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                carExpiresType: this.formInline.carExpiresType,
                carExpiresTimeStar: startTime,
                carExpiresTimeEnd: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('VehicleAnnualReview/GET_GETCARANNUALAPPROVELIST', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllCar()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                carExpiresType: '',
                carExpiresTime: [],
            }
            this.getAllCar()
        },

        carAnnualReview() {
            this.dialogFormVisible = true
            this.btnType = "carAnnualReview"
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.carId = this.selected[0].carId
                this.form.manufactureNum = this.selected[0].manufactureNum
                this.form.customNum = this.selected[0].customNum
                this.form.plateNum = this.selected[0].plateNum
                this.form.carExpires = this.selected[0].carExpires
                this.form.filePath = ''
                this.imageUrl = ''
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        carId: this.form.carId,
                        nowExpireDate: this.form.carExpires,
                        expiresInstitution: this.form.expiresInstitution,
                        changeExpireDate: this.form.changeExpireDate,
                        carExpiresNum: this.form.carExpiresNum,
                        filePath: this.form.filePath,
                    }
                    console.log(param)
                    this.$store.dispatch('VehicleAnnualReview/GET_SUBMITCARAUDIT', param).then(res => {
                        if (res.data.code == 200) {
                            if (this.btnType == "carAnnualReview") {
                                this.$message.success(this.$t('VehicleManagement.form.carAnnualAuditSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllCar();
                                this.closeDia();
                            } else {
                                this.$message.success(this.$t('VehicleManagement.form.carAnnualAuditSuccess'))
                                this.dialogFormVisible = false;
                                this.getOperateList();
                                this.closeDia();
                            }
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })

                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                carId: '',
                manufactureNum: '',
                customNum: '',
                plateNum: '',
                carExpires: '',
                changeExpireDate: '',
                carExpiresNum: '',
                filePath: '',
                expiresInstitution: ''
            }
        },
        closeDia() {
            this.form = {
                carId: '',
                manufactureNum: '',
                customNum: '',
                plateNum: '',
                carExpires: '',
                changeExpireDate: '',
                carExpiresNum: '',
                filePath: '',
                expiresInstitution: ''
            }
            this.dialogFormVisible = false;
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
            this.form.filePath = res[0]
        },
        handleRemove(file, fileList) { },

        reAnnualReview() {
            this.dialogFormVisible = true
            this.btnType = "reAnnualReview"
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.carId = this.selected[0].carId
                this.form.manufactureNum = this.selected[0].manufactureNum
                this.form.customNum = this.selected[0].customNum
                this.form.plateNum = this.selected[0].plateNum
                this.form.carExpires = this.selected[0].carExpires
            })
        },
        ApprovalProgress() {
            this.dialogOperateFormVisible = true
            this.getOperateList()
        },
        getOperateList() {
            let param = {
                auditType: 0,
                carId: this.selected[0].carId,
                pageNum: this.OperatesCurrentPage,
                pageSize: this.OperatesPageSize,
            }
            this.$store.dispatch('VehicleAnnualReview/GET_GETCARAPPROVEPROGRESSLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.operatesList = res.data.data.list
                        this.$refs.OperatesPage.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        changeOperatesSize(item) {
            this.OperatesPageSize = item.pageSize
            this.OperatesCurrentPage = item.pageNum
            this.getOperateList()
        },
        handleOperatesChange(val) {
            this.select = val
        },

        closeImgDia() {
            this.dialogImgFormVisible = false
        },

        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let startTime = ''
                    let endTime = ''
                    if (this.formInline.carExpiresTime) {
                        if (this.formInline.carExpiresTime.length > 0) {
                            startTime = this.formInline.carExpiresTime[0]
                            endTime = this.formInline.carExpiresTime[1]
                        }
                    }
                    let companyId = sessionStorage.getItem("companyId")

                    let url = `https://${domainName}/v1/getExportExcel/exportCarAnnualApproveList?orgId=${this.id}&companyId=${companyId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&carExpiresType=${this.formInline.carExpiresType}&carExpiresTimeStar=${startTime}&carExpiresTimeEnd=${endTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportCarAnnualApproveList?orgId=${this.id}&companyId=${companyId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&carExpiresType=${this.formInline.carExpiresType}&carExpiresTimeStar=${startTime}&carExpiresTimeEnd=${endTime}`
                    location.href = url


                }
            }
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllCar();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}